module.exports = __webpack_public_path__ + "static/media/cartridges_banner.52799963.png";